import * as t from 'io-ts';

import {
  ContactsManagerSidePanelTypesEnum,
  RContactsManagerSidePanelStateBase,
} from './contactsManagerSidePanelStateBase';

/*
 * Runtime types.
 */

export const RAccountDetailsStateDirty = t.intersection([
  RContactsManagerSidePanelStateBase,
  t.type({
    type: t.literal(ContactsManagerSidePanelTypesEnum.ACCOUNT_DETAILS),
  }),
]);

/*
 * Types.
 */

export interface AccountDetailsState extends Readonly<t.TypeOf<typeof RAccountDetailsStateDirty>> {}
export const RAccountDetailsState = t.clean<AccountDetailsState>(RAccountDetailsStateDirty as any);
